// extracted by mini-css-extract-plugin
export default {"auth":"layout_auth__5fBmt","main-content-view":"layout_main-content-view__frEGF","authScroll":"layout_authScroll__JSJ4x"};